import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import TipoDocsProvider from "./TipoDocsContext";
import PesquisarTipoDocs from "./Events/PesquisarTipoDocs";
import FormularioTipoDocs from "./Events/FormularioTipoDocs";

const Index = () => {
  let match = useRouteMatch();
  return (
    <TipoDocsProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarTipoDocs}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioTipoDocs}
          />
        </Switch>
      </div>
    </TipoDocsProvider>
  );
};

export default Index;
